import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {HttpUtilsService} from '../_base/crud';
import { UserModel } from '../auth';

const API_PUSH_URL = `${environment.pathToAPI}/api/v1/push_notification`;

const PROJECT_MODIFIED_TITLE = 'PROJECT_MODIFIED_TITLE';
const PROJECT_MODIFIED_BODY = 'PROJECT_MODIFIED_BODY';
const CONVERSATION_MODIFIED_TITLE = 'CONVERSATION_MODIFIED_TITLE';
const CONVERSATION_MODIFIED_BODY = 'CONVERSATION_MODIFIED_BODY';
const MESSAGE_ADDED_TITLE = 'MESSAGE_ADDED_TITLE';
const MESSAGE_ADDED_BODY = 'MESSAGE_ADDED_BODY';
const DIRECT_MESSAGE_ADDED_BODY = 'DIRECT_MESSAGE_ADDED_BODY';

type TitleId = typeof PROJECT_MODIFIED_TITLE | typeof CONVERSATION_MODIFIED_TITLE | typeof MESSAGE_ADDED_TITLE;
type BodyId = typeof PROJECT_MODIFIED_BODY | typeof CONVERSATION_MODIFIED_BODY | typeof MESSAGE_ADDED_BODY | typeof DIRECT_MESSAGE_ADDED_BODY;
type NotificationTranslationId = TitleId | BodyId;

@Injectable()
export class PushNotificationService {
    constructor(
        private http: HttpClient,
        private httpUtils: HttpUtilsService
    ) {
    }

    getTranslatedValues(lang: string, expectedData: NotificationTranslationId, username: string= '', objectName: string= '', messageBody?: string) {
        if (lang === 'en') {
            if (expectedData === PROJECT_MODIFIED_TITLE) {
                return 'Project Name Modified';
            } else if (expectedData === PROJECT_MODIFIED_BODY) {
                return `${username} has modified ${objectName} Project.`;
            } else if (expectedData === CONVERSATION_MODIFIED_TITLE) {
                return `Chat Group Modified`;
            } else if (expectedData === CONVERSATION_MODIFIED_BODY) {
                return `${username} has modified ${objectName} Chat Group.`;
            } else if (expectedData === MESSAGE_ADDED_TITLE) {
                return `New Message`;
            } else if (expectedData === MESSAGE_ADDED_BODY) {
                return `${username} has sent a new message to ${objectName}: ${messageBody}`;
            } else if (expectedData === DIRECT_MESSAGE_ADDED_BODY) {
                return `You have received a message from ${username}: ${messageBody}`;
            } else {
                return null;
            }
        } else if (lang === 'ja') {
            if (expectedData === PROJECT_MODIFIED_TITLE) {
                return 'プロジェクト名の変更';
            } else if (expectedData === PROJECT_MODIFIED_BODY) {
                return `${username}は${objectName}プロジェクトを変更しました。`;
            } else if (expectedData === CONVERSATION_MODIFIED_TITLE) {
                return `チャットグループの変更`;
            } else if (expectedData === CONVERSATION_MODIFIED_BODY) {
                return `${username}が${objectName} チャットグループを変更しました。`;
            } else if (expectedData === MESSAGE_ADDED_TITLE) {
                return `新しいメッセージ`;
            } else if (expectedData === MESSAGE_ADDED_BODY) {
                return `${username}が${objectName}に新しいメッセージを送信しました: ${messageBody}`;
            } else if (expectedData === DIRECT_MESSAGE_ADDED_BODY) {
                return `${username}から新しいメッセージが受信されました: ${messageBody}`;
            } else {
                return null;
            }
        } else if (lang === 'es') {
            if (expectedData === PROJECT_MODIFIED_TITLE) {
                return 'Proyecto modificado';
            } else if (expectedData === PROJECT_MODIFIED_BODY) {
                return `${username} ha modificado ${objectName} Proyect`;
            } else if (expectedData === CONVERSATION_MODIFIED_TITLE) {
                return `Grupo de chat modificado`;
            } else if (expectedData === CONVERSATION_MODIFIED_BODY) {
                return `${username} ha modificado ${objectName} Grupo de chat`;
            } else if (expectedData === MESSAGE_ADDED_TITLE) {
                return `Nuevo mensaje`;
            } else if (expectedData === MESSAGE_ADDED_BODY) {
                return `${username} ha enviado un nuevo mensaje a ${objectName}: ${messageBody}`;
            } else if (expectedData === DIRECT_MESSAGE_ADDED_BODY) {
                return `Has recibido un mensaje de ${username}: ${messageBody}`;
            } else {
                return null;
            }
        } else if (lang === 'my') {
            if (expectedData === PROJECT_MODIFIED_TITLE) {
                return 'စီမံကိန်းပြုပြင်မွမ်းမံ';
            } else if (expectedData === PROJECT_MODIFIED_BODY) {
                return `${username} သည် ${objectName} စီမံကိန်းကိုပြုပြင်ပြောင်းလဲခဲ့သည်။`;
            } else if (expectedData === CONVERSATION_MODIFIED_TITLE) {
                return `Chat Group Modified`;
            } else if (expectedData === CONVERSATION_MODIFIED_BODY) {
                return `${username} ${objectName} Chat Group ကိုပြင်ဆင်ပြီးပါပြီ။ `;
            } else if (expectedData === MESSAGE_ADDED_TITLE) {
                return `သတင်းအသစ်`;
            } else if (expectedData === MESSAGE_ADDED_BODY) {
                return `${username} ${objectName} သို့သတင်းစကားအသစ်တစ်ခုကိုပို့လိုက်သည်။: ${messageBody}`;
            } else if (expectedData === DIRECT_MESSAGE_ADDED_BODY) {
                return `${username} မှသတင်းစကားအသစ်ကိုလက်ခံရရှိခဲ့သည်။: ${messageBody}`;
            } else {
                return null;
            }
        } else if (lang === 'vi') {
            if (expectedData === PROJECT_MODIFIED_TITLE) {
                return 'Dự án sửa đổi';
            } else if (expectedData === PROJECT_MODIFIED_BODY) {
                return `${username} đã sửa đổi Dự án ${objectName}.`;
            } else if (expectedData === CONVERSATION_MODIFIED_TITLE) {
                return `Nhóm trò chuyện đã sửa đổi`;
            } else if (expectedData === CONVERSATION_MODIFIED_BODY) {
                return `${username} đã sửa đổi ${objectName} Nhóm trò chuyện.`;
            } else if (expectedData === MESSAGE_ADDED_TITLE) {
                return `Tin nhắn mới`;
            } else if (expectedData === MESSAGE_ADDED_BODY) {
                return `${username} đã gửi một tin nhắn mới tới ${objectName}: ${messageBody}`;
            } else if (expectedData === DIRECT_MESSAGE_ADDED_BODY) {
                return `Tin nhắn mới nhận được từ ${username}: ${messageBody}`;
            } else {
                return null;
            }
        } else if (lang === 'zh') {
            if (expectedData === PROJECT_MODIFIED_TITLE) {
                return '项目修改';
            } else if (expectedData === PROJECT_MODIFIED_BODY) {
                return `${username}已修改${objectName}项目。`;
            } else if (expectedData === CONVERSATION_MODIFIED_TITLE) {
                return `聊天组已修改i`;
            } else if (expectedData === CONVERSATION_MODIFIED_BODY) {
                return `${username}已修改${objectName}聊天组。`;
            } else if (expectedData === MESSAGE_ADDED_TITLE) {
                return `新消息`;
            } else if (expectedData === MESSAGE_ADDED_BODY) {
                return `${username}已向${objectName}发送了一条新消息: ${messageBody}`;
            } else if (expectedData === DIRECT_MESSAGE_ADDED_BODY) {
                return `從${username}收到新消息: ${messageBody}`;
            } else {
                return null;
            }
        }
    }

    sendPushNotificationToBackEnd(data: any, token?: string | null) {
        const httpHeaders = this.httpUtils.getHTTPHeaders(token);
        const url = `${API_PUSH_URL}/send-push-notification`;
        return this.http.post(url, data, {headers: httpHeaders});
    }

    sendWebPushNotificationToBackEnd(data: any) {
        const httpHeaders = this.httpUtils.getHTTPHeaders();
        const url = `${API_PUSH_URL}/send-web-push-notification`;
        return this.http.post(url, {subscription: data}, {headers: httpHeaders});
    }

    /**
     * 
     * @param users 通知を送るユーザーのリスト
     * @param currentUser 現在のユーザ
     * @param objectName 関連するデータの名前
     * @param bodyId 本文のID
     * @param titleId タイトルのID
     * @param link リンク
     * @param body 本文
     * @returns プッシュ通知に送るデータ
     */
    dataForSendingPushNotificationToMobile(
        users: UserModel[],
        currentUser: UserModel,
        objectName: string,
        bodyId: BodyId,
        titleId: TitleId,
        link: string,
        messageBody: string | undefined) {
        const data: {
            to: number;
            android: {
                message: string | undefined | null;
                title: string | undefined | null;
                link: string
            };
            ios: {
                message: string | undefined | null;
                link: string;
            }
        }[] = [];
        const usersWithoutCurrentUser = users.filter(user => user.id !== currentUser.id);
        usersWithoutCurrentUser.forEach((user) => {
            const message = this.getTranslatedValues(
                user.language,
                bodyId,
                currentUser.fullname,
                objectName,
                messageBody,
            );
            const title = this.getTranslatedValues(user.language, titleId);
            const body = {
                to: user.id,
                android: {
                    message,
                    title,
                    link,
                },
                ios: {
                    message,
                    link
                }
            };
            data.push(body);
        });
        return {
            sns : data,
        };
    }
}
